import React from "react"
import { IconCircleInfoOutline18 as InfoIcon } from "nucleo-ui-outline-18"

import { Tooltip } from "@productlane/ui"

export const TrendTooltip = React.memo(() => {
	return (
		<Tooltip label="Priority score increase in the last 4 weeks">
			<InfoIcon className="h-3 w-3 flex-none text-tertiary hover:text-primary" />
		</Tooltip>
	)
})
